import React, {useState, useEffect} from  'react';
import api from '../../services/api';
import Select from 'react-select';

export default function AttendantsSelect(props){

    const [attendants, setAttendants] = useState([]);
    const [defaultValue, setDefaultValue] = useState(null);
    const [options, setOptions] = useState([]);

    const onChange = (option) => {        
        props.onChange(option.value);
    };

    const getAttendants = () => {
        api.get('/users/attendants')
        .then(response => {     
            setAttendants(response.data.data);                   
        });         
    }

    const getOptions = () => {
        let options = [
            {value: null, label: (props.label ? props.label : '-- Selecione --')} 
        ];        
        attendants.map((item, index) => {
            let option = {
                value: item.id,
                label: item.attributes.name
            };
            options.push(option);
        });
        setOptions(options);         
    };   

    useEffect(() => {        
        getAttendants();
    }, []);

    useEffect(() => {
        getOptions();
    }, [attendants]);   
    
    useEffect(() => {
        options.map((option, index) => {            
            if(option.value == props.defaultValue){
                setDefaultValue(option);                
            }            
        });
    }, [options]);

    return (
        <>
            {(options && defaultValue) && <Select options={options} defaultValue={defaultValue} onChange={onChange} />}
        </>
    );

}